<template>
  <div :class="$style.root">
    <div :class="$style.content">
      <Table>
        <thead>
          <tr>
            <th>名字</th>
            <th>電郵</th>
            <th>管理員</th>
            <th width="100">
              <input 
                type="text" 
                placeholder="搜尋" 
                v-model="search"
                @keydown.enter="handleFilter"
              />
            </th>
          </tr>
        </thead>
        <tbody>
          <UserListRow
            v-for="user in users"
            :key="user.id"
            :user="user"
            @edit="handleEdit"
          />
        </tbody>
      </Table>
      <Pager v-if="stats" :total="stats.count" :page="page" :size="pageSize" @change="handlePageChange" />
    </div>
    <UserForm
      v-if="editUser"
      :user="editUser"
      @change="handleUpdate"
      @close="editUser = null"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Table from './Table'
import UserListRow from './UserListRow'
import UserForm from './UserForm'
import Pager from './Pager'
import pick from 'lodash/pick'

export default {
  components: {
    Table,
    UserListRow,
    UserForm,
    Pager,
  },
  data () {
    return {
      users: [],
      stats: null,
      page: 1,
      pageSize: 10,
      editUser: null,
      search: '',
    }
  },
  mounted () {
    this.fetchStats()
    this.fetchUsers()
  },
  methods: {
    async fetchUsers (page = this.page) {
      try {
        const { data } = await this.httpGet({
          url: '/admin/user',
          query: { page, pageSize: this.pageSize, q: this.search },
        })

        this.users = data
      } catch (e) {
        //
      }
    },
    async fetchStats () {
      try {
        const { data } = await this.httpGet({
          url: '/admin/user/stats',
          query: { q: this.search },
        })

        this.stats = data
      } catch (e) {
        //
      }
    },
    async updateUser (user) {
      try {
        const resp = await this.httpPut({
          url: '/admin/user/' + user.id,
          data: pick(user, 'name', 'login', 'role'),
        })

        await this.fetchUsers()
      } catch (e) {
        //
      }
    },
    handleEdit (user) {
      this.editUser = user
    },
    async handleUpdate (user) {
      await this.updateUser(user)
      this.editUser = null
    },
    async handleFilter () {
      this.page = 1
      await Promise.all([
        this.fetchUsers(),
        this.fetchStats(),
      ])
    },
    async handlePageChange (page) {
      if (this.page == page) {
        return
      }

      this.page = page
      await this.fetchUsers()
    },
    ...mapActions('http', {
      httpGet: 'get',
      httpPut: 'put',
    }),
  },
}
</script>

<style lang="scss" module>
.root {
  @apply h-full;
  @apply overflow-y-scroll;
}

.content {
  @apply py-4;
  @apply px-8;
}
</style>
